import { Component } from '@angular/core';
import { BlAccountAuthService } from '../core/services/bl-account-auth.service';
import { getTranslationProvider } from '../core/i18n/getTranslationProvider';
import { TranslatableComponent } from '../core/i18n/TranslatableComponent';

@Component({
  template: `<ng-container *transloco="let t; prefix: scope">{{ t('youAreBeingLoggedInPleaseWait') }}</ng-container>`,
  providers: [getTranslationProvider('LoginComponent')],
})
export class SilentAuthComponent extends TranslatableComponent {
  // This is a landing page for apigateway after success login.
  // The page will only be loaded and then closed inside the popup.
  // The real app is loaded in the main browser.
  // This page MUST have the BlAccountAuthService injected to init the listening of JWT param so the popup can be closed.
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  constructor(_blAccoutAuthService: BlAccountAuthService) {
    super();
  }
}
